uniform float uTime;
uniform vec2 uResolution;
#define PI 3.1415926538

varying vec2 vUv;

vec3 drawCircle(vec2 pos, float width)
{
    float dist1 = length(pos);
    dist1 = fract((dist1 * 5.0) - 0.25);// - fract(uTime * 0.1));

    float t1 = 1.0 - smoothstep(0.0, width, abs(dist1));
    float t2 = 0.0 + smoothstep(0.0, width, abs(dist1));
    float t3 = t1 * t2;

    vec3 col = vec3(t3);

    return col;
}

//  Function from Iñigo Quiles
//  www.iquilezles.org/www/articles/functions/functions.htm
float drawLine( float c, float w, float x ){
    x = abs(x - c);
    if( x>w ) return 0.0;
    x /= w;
    return 1.0 - x*x*(3.0-2.0*x);
}

// https://thebookofshaders.com/05/
float diagonal1(vec2 st) {    
    return smoothstep(0.0005, 0.0, abs(st.y - st.x));
}

float diagonal2(vec2 st) {    
    return smoothstep(0.0005, 0.0, abs(1.0 - st.y - st.x));
}

// THE ART OF CODE YOUTUBE
mat2 Rot(float a) {
  float s = sin(a), c = cos(a);
  return mat2(c, -s, s, c);
}

void main() {

    vec2 uv = (vUv * 2.0 - 1.0) * 2.0;
    
    float width = 0.025;
    float power = 0.5;
    vec3 color = drawCircle(uv, width) * 2.0;

    float r = mod(uTime * 0.4, 3.0);
	float dist = sqrt(dot(uv, uv));
    float pulse = 1.0 + smoothstep(r, r+0.1, dist) - smoothstep(r-0.1, r, dist);

    color += (1.0 - pulse) * 0.2;

    // uv = vUv;
    // color += drawLine(0.5,0.0005,uv.x) * 0.5;
    // color += drawLine(0.5,0.0005,uv.y) * 0.5;

    // color += diagonal1(uv) * 0.5;
    // color += diagonal2(uv) * 0.5;
    
    //uv = vUv - vec2(0.5);



    dist = length(uv);
    float alpha = 0.1 / dist;

    float hole = smoothstep(0.012,0.014,dist);
    color *= hole;

    gl_FragColor = vec4(color, alpha);
}